import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";

interface Props {
  idEmpresaVendas: string;
}

export function useEquipesPorEmpresaVendas(props: Props) {
  const fetchData = async () => {
    if (props.idEmpresaVendas === undefined) {
      return null;
    }
    const LISTAR_EQUIPES_POR_EMPRESA = `identity/admin/hierarquias/equipes-por-empresa-vendas/v1?idEmpresaVendas=${props.idEmpresaVendas}`;
    const response = await instance.get(LISTAR_EQUIPES_POR_EMPRESA);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    refetchOnWindowFocus: false,
    queryKey: ["listar_equipe_por_empresas"],
    refetchOnMount: false,
    enabled: false,
  });
  return query;
}
